<template>
	<div>
		<el-container >
			<el-aside width="300px">
				<el-form ref="locationForm">
					<!-- <el-form-item>
						<el-button type="primary" @click="groupDialogVisible = true">添加</el-button>
					</el-form-item> -->
					<el-form-item>
						<el-table
							ref="groupTable"
							:data="groupListData"
							tooltip-effect="dark"
							style="margin-top: -5px;"
							:height="listHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '8px'}"
							:header-cell-style="{background: '#E6F2FE', height:'4px',padding:'4px'}"
							border
							stripe
							@row-click="groupRowClick">

						<!-- <el-table-column
								type="selection"
								width="55">
						</el-table-column> -->

						<el-table-column
								prop="groupName"
								label="组团名称"
								show-overflow-tooltip>
						</el-table-column>

						<!-- <el-table-column
								prop="icon"
								label="操作">

							<template slot-scope="scope">

								<el-button type="text" @click="editGroupHandle(scope.row.id)">编辑</el-button>
								<el-divider direction="vertical"></el-divider>

								<template>
									<el-popconfirm title="删除组团将会解绑设备和人员，确定要删除吗？" @confirm="delGroupHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>

							</template>
						</el-table-column> -->

					</el-table>
					</el-form-item>
				</el-form>
			</el-aside>

			<el-container>
				<el-header >
					<el-form :inline="true" >
						<el-form-item>
							<el-input
									v-model="searchForm.code"
									placeholder="人员号"
									clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input
									v-model="searchForm.name"
									placeholder="姓名"
									clearable
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-button @click="getPinWhiteList">搜索</el-button>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="addMachineList">添加人员</el-button>
						</el-form-item>

						<el-form-item>
							<el-popconfirm title="确定批量删除人员吗？" @confirm="delHandle(null)">
								<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
							</el-popconfirm>
						</el-form-item>
					</el-form>
				</el-header>

				<el-main>
					<el-table
							ref="multipleTable"
							:data="groupPersonData"
							tooltip-effect="dark"
							style="width: 100%; margin-top: -20px;"
							:height="tableHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handleSelectionChange">

						<el-table-column
								type="selection"
								width="55">
						</el-table-column>

						<el-table-column
								prop="groupName"
								label="组团名称"
								show-overflow-tooltip
								width="130">
						</el-table-column>

						<el-table-column
								prop="personNo"
								label="人员号"
								width="120">
						</el-table-column>

						<el-table-column
								prop="personName"
								label="姓名"
								width="120">
						</el-table-column>

						<el-table-column
							prop="personSex"
							label="性别"
							width="70"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
								<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
								<el-tag size="small" v-else type="danger">未知</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="deptFullName"
								label="部门"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="beginTime"
								label="开始时间"
								width="120"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="endTime"
								label="结束时间"
								width="120"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="icon"
								label="操作"
								width="120">

							<template slot-scope="scope">

								 <template>
									<el-popconfirm title="确定删除该人员吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>

							</template>
						</el-table-column>

					</el-table>

					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:page-sizes="[10, 20, 50, 100]"
							:current-page="current"
							:page-size="size"
							:total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--组团新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="groupDialogVisible"
				width="600px"
				:before-close="groupHandleClose"
				:close-on-click-modal="false">

			<el-form :model="editGroupForm" :rules="editGroupFormRules" ref="editGroupForm" label-width="100px" class="demo-editForm">

				<el-form-item label="组团名称" prop="groupName" label-width="100px">
					<el-input v-model="editGroupForm.groupName" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetGroupForm('editGroupForm')">取 消</el-button>
				<el-button type="primary" @click="submitGroupForm('editGroupForm')">确 定</el-button>
			</div>
		</el-dialog>

		<!--新增对话框-->
		<el-dialog
				:title="selectedGroupInfo"
				:visible.sync="dialogVisible"
				width="1000px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-container style="margin-top: -20px;">
					<el-aside width="250px">
						<DeptTree @getTreeData="deptTreeNodeClick"/>
					</el-aside>
					<el-main>
						<el-form :inline="true" style="margin-top: -20px;">
							<el-form-item>
								<el-input
										v-model="searchPersonForm.code"
										placeholder="人员号"
										clearable
								>
								</el-input>
							</el-form-item>
							<el-form-item>
								<el-input
										v-model="searchPersonForm.name"
										placeholder="姓名"
										clearable
								>
								</el-input>
							</el-form-item>

							<el-form-item>
								<el-button @click="getPersonList">搜索</el-button>
							</el-form-item>
						</el-form>
						<el-table
							class="show_table"
							ref="personTable"
							:data="personData"
							height="370"
							tooltip-effect="dark"
							:row-style="{height: '4px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handlePersonSelectionChange">

							<el-table-column
									type="selection"
									width="55">
							</el-table-column>

							<el-table-column
									prop="personNo"
									label="人员号"
									width="100">
							</el-table-column>

							<el-table-column
									prop="personName"
									label="姓名"
									width="100">
							</el-table-column>

							<el-table-column
									prop="personSex"
									label="性别"
									width="70"
									show-overflow-tooltip>
									<template slot-scope="scope">
									<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
									<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
									<el-tag size="small" v-else type="danger">未知</el-tag>
								</template>
							</el-table-column>

							<el-table-column
									prop="identityName"
									label="身份"
									width="100"
									show-overflow-tooltip>
							</el-table-column>

							<el-table-column
									prop="fullName"
									label="部门"
									show-overflow-tooltip>
							</el-table-column>

						</el-table>
						<el-form-item label="有效日期" label-width="100px" style="margin-top: 10px;">
							<el-date-picker 
								v-model="validDate" 
								type="daterange" 
								value-format="yyyy-MM-dd"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
					</el-main>
				</el-container>
			</el-form>

			<div slot="footer" class="dialog-footer" style="margin-top: -50px;">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="saveWhiteListHandle">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import DeptTree from '../base/DeptTree.vue'
	import LocationTree from "../base/LocationTree.vue"
	export default {
		name: "GroupPerson",
		components:{LocationTree, DeptTree},
		data() {
			return {
				searchForm: {},
				searchMachineForm: {},
				searchPersonForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				machineDialogVisible: false,
				editMachineForm:{},

				dialogVisible: false,
				editForm: {
					beginDate: '',
					endDate: ''
				},

				groupDialogVisible: false,
				editGroupForm: {},

				locationForm: {

				},

				tableData: [],
				machineData: [],
				personData: [],
				groupListData: [],
				groupMachineData: [],
				groupPersonData: [],

				selectedGroupId:'',
				selectedGroupInfo:'',

				editGroupFormRules: {
					groupName: [
						{required: true, message: '请输入组团名称', trigger: 'blur'}
					]
				},

				editFormRules: {
					validDate: [
						{required: true, message: '请选择有效日期范围', trigger: 'blur'}
					]
				},

				multipleSelection: [],
				multipleMachineSelection: [],
				multiplePersonSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'personName'
				},
				permTreeData: [],
				treeSelectDeptId: 0,
				treeSelectLocationId: 0,
				validDate: []
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 630: 550
			},
			listHeight: function() {
				return screen.height > 900 ? 695: 566
			}
		},
		created() {
			this.getGroupList()
			// this.getPinWhiteList()
			// this.$axios.get('/base/person/list').then(res => {
			// 	this.permTreeData = res.data.data
			// })
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},
			handlePersonSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multiplePersonSelection = val;
			},

			handleMachineSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleMachineSelection = val;
			},

			groupRowClick(row) {
				console.log('row', row);
				this.selectedGroupId = row.id;
				this.selectedGroupInfo = "[" + row.groupName + "] 名单授权";
				this.getGroupPersonList();
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getPinWhiteList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getPinWhiteList()
			},
			resetGroupForm(formName) {
				this.$refs[formName].resetFields();
				this.groupDialogVisible = false
				this.editGroupForm = {}
			},
			groupHandleClose() {
				this.resetGroupForm('editGroupForm')
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			resetMachineForm(formName) {
				this.$refs[formName].resetFields();
				this.machineDialogVisible = false
				this.editMachineForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			
			deptTreeNodeClick(deptdata) {
				this.treeSelectDeptId = deptdata.id;
				this.getPersonList();
			},

			getPersonList() {
				this.$axios.get("/base/person/list", {
					params: {
						code: this.searchPersonForm.code,
						name: this.searchPersonForm.name,
						deptId: this.treeSelectDeptId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.personData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getGroupList() {
				this.$axios.get("/pin/group/list", {
					params: {
						current: 1,
						size: 1000
					}
				}).then(res => {
					this.groupListData = res.data.data.records
					console.log('groupListData=', this.groupListData)
				})
			},

			getGroupPersonList() {
				this.$axios.get("/pin/group/personlist", {
					params: {
						groupId: this.selectedGroupId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.groupPersonData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			addMachineList() {
				//添加设备名单
				if (this.selectedGroupId === '') {
					this.$message({
						showClose: true,
						message: '请先选择组团',
						type: 'warning',
						onClose:() => {
							this.getPinWhiteList()
						}
					});
				} else {
					this.dialogVisible = true
				}

			},

			submitGroupForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.editGroupForm);
						this.$axios.post('/pin/group/' + (this.editGroupForm.id?'update' : 'save'), this.editGroupForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.getGroupList()
									}
								});

								this.groupDialogVisible = false
								this.resetGroupForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editGroupHandle(id) {
				this.$axios.get('/pin/group/info/' + id).then(res => {
					this.editGroupForm = res.data.data

					this.groupDialogVisible = true
				})
			},
			delGroupHandle(id) {

				var ids = []

				ids.push(id)

				console.log(ids)

				this.$axios.post("/pin/group/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getGroupList()
						}
					});
				})
			},
			editHandle(id) {
				this.$axios.get('/pin/whitelist/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/pin/group/persondelete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getGroupPersonList()
						}
					});
				})
			},
			saveWhiteListHandle() {

				console.log("this.validDate[0]", this.validDate[0]);

				var personIds = []

				this.multiplePersonSelection.forEach(row => {
					personIds.push(row.id)
				})

				var params = {
					groupId: this.selectedGroupId,
					personIdList: personIds,
					beginDate: this.validDate[0],
					endDate: this.validDate[1]
				}

				this.$axios.post("/pin/group/personsave", params)
				.then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getGroupPersonList()
						}
					});
					this.dialogVisible = false
				})
			},
			tableRowStyleName ({row}) {
				if (this.selectedGroupId == row.id) {
					return 'background-color: #E0E0E0 !important;';
				}
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 100%;
	}
	.el-table .warning-row {
		background: pink!important;
	}
	.show_table {
		position: relative;
		width: 100%;
		height: 370px;
		overflow: auto;
		margin-top: -15px;
	}
</style>